// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardTermsOfServiceRouteImport } from './routes/_dashboard/terms-of-service'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardPrivacyRouteImport } from './routes/_dashboard/privacy'
import { Route as DashboardNotificationsRouteImport } from './routes/_dashboard/notifications'
import { Route as DashboardCreatePollRouteImport } from './routes/_dashboard/create-poll'
import { Route as DashboardBookmarksRouteImport } from './routes/_dashboard/bookmarks'
import { Route as DashboardAvatarRouteImport } from './routes/_dashboard/avatar'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as DashboardProfileUsernameRouteImport } from './routes/_dashboard/profile/$username'
import { Route as DashboardFollowingUsernameRouteImport } from './routes/_dashboard/following/$username'
import { Route as DashboardFollowersUsernameRouteImport } from './routes/_dashboard/followers/$username'
import { Route as DashboardPollShortIdSlugRouteImport } from './routes/_dashboard/poll/$shortId/$slug'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardTermsOfServiceRoute = DashboardTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRouteRoute
          })
const DashboardPrivacyRoute = DashboardPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => DashboardRouteRoute
          })
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCreatePollRoute = DashboardCreatePollRouteImport.update({
            id: '/create-poll',path: '/create-poll',getParentRoute: () => DashboardRouteRoute
          })
const DashboardBookmarksRoute = DashboardBookmarksRouteImport.update({
            id: '/bookmarks',path: '/bookmarks',getParentRoute: () => DashboardRouteRoute
          })
const DashboardAvatarRoute = DashboardAvatarRouteImport.update({
            id: '/avatar',path: '/avatar',getParentRoute: () => DashboardRouteRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRouteRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRouteRoute
          })
const DashboardProfileUsernameRoute = DashboardProfileUsernameRouteImport.update({
            id: '/profile/$username',path: '/profile/$username',getParentRoute: () => DashboardRouteRoute
          })
const DashboardFollowingUsernameRoute = DashboardFollowingUsernameRouteImport.update({
            id: '/following/$username',path: '/following/$username',getParentRoute: () => DashboardRouteRoute
          })
const DashboardFollowersUsernameRoute = DashboardFollowersUsernameRouteImport.update({
            id: '/followers/$username',path: '/followers/$username',getParentRoute: () => DashboardRouteRoute
          })
const DashboardPollShortIdSlugRoute = DashboardPollShortIdSlugRouteImport.update({
            id: '/poll/$shortId/$slug',path: '/poll/$shortId/$slug',getParentRoute: () => DashboardRouteRoute
          })





const AuthRouteRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const DashboardRouteRouteChildren = {
  DashboardAvatarRoute: DashboardAvatarRoute,DashboardBookmarksRoute: DashboardBookmarksRoute,DashboardCreatePollRoute: DashboardCreatePollRoute,DashboardNotificationsRoute: DashboardNotificationsRoute,DashboardPrivacyRoute: DashboardPrivacyRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardTermsOfServiceRoute: DashboardTermsOfServiceRoute,DashboardIndexRoute: DashboardIndexRoute,DashboardFollowersUsernameRoute: DashboardFollowersUsernameRoute,DashboardFollowingUsernameRoute: DashboardFollowingUsernameRoute,DashboardProfileUsernameRoute: DashboardProfileUsernameRoute,DashboardPollShortIdSlugRoute: DashboardPollShortIdSlugRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)

const rootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)